import { render, staticRenderFns } from "./risk-first-trial.vue?vue&type=template&id=d54f4744&scoped=true&"
import script from "./risk-first-trial.vue?vue&type=script&lang=js&"
export * from "./risk-first-trial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54f4744",
  null
  
)

export default component.exports